/**
 * Конфигурация рантайма web-ui. Значения берутся из Vite env (import.meta.env).
 * В dev `/api` и `/auth` проксируются на bff-ui (см. vite.config.ts).
 */
export const config = {
  /** Базовый префикс API (пустой = same-origin через прокси/ingress). */
  apiBase: import.meta.env.VITE_API_BASE ?? '',
  /** Sentry DSN (пусто = Sentry в no-op режиме). */
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  /** Окружение для Sentry/телеметрии. */
  environment: import.meta.env.VITE_ENVIRONMENT ?? import.meta.env.MODE,
  /** Версия сборки (для Sentry release). */
  release: import.meta.env.VITE_RELEASE ?? '0.1.0',
} as const;
